<template>
  <v-container fluid class="creativeproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-folder</v-icon>
            Project
          </v-tab>
          <v-tab
            :href="`#tab-response`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-edit</v-icon>
            Response
          </v-tab>
          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center" style="margin-top: 5px;">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">{{ initvalue.projectname }}</p>
                      </v-col>
                      <v-col md="1" align="right">
                        <v-btn
                        class="button-shadow"
                        color="primary"
                      @click="Done"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="no-gutters" style="margin-left: 5px;">
                <v-col cols="12" md="2">
                  <div style="align-content: top;">
                    <v-img
                        v-if="initvalue.projectimage" 
                        v-bind:src="initvalue.projectimage"
                        max-height="170"
                        max-width="170"
                        contain
                    ></v-img>
                  </div>
                </v-col>
                <v-col cols="12" md="10">
                  <v-row class="no-gutters">
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        
                        <tr>
                          <td><span style="font-weight: 700;">Date</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Channel</span></td>
                          <td>{{ initvalue.projectchannel }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Type</span></td>
                          <td>{{ initvalue.projecttype }}</td>
                        </tr>
                        <tr v-if="initvalue.projectchannel=='Writing'">
                          <td><span style="font-weight: 700;">Language</span></td>
                          <td>{{ initvalue.languagecode }}</td>
                        </tr>
                        <tr v-if="initvalue.projectchannel=='Design'">
                          <td><span style="font-weight: 700;">Format</span></td>
                          <td>{{ initvalue.projectformat }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Marketing</span></td>
                          <td>{{ initvalue.mktprojectname }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Business</span></td>
                          <td>{{ initvalue.bizprojectid }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td style="vertical-align: text-top;"><span style="font-weight: 700;">Requestor</span></td>
                          <td>
                            <p class="two-line">{{ initvalue.requestorname }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: text-top;"><span style="font-weight: 700;">Creator</span></td>
                          <td>
                            <p v-if="initvalue.repid!=null" class="two-line">{{ initvalue.creatorname  }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Complete By</span></td>
                          <td>{{ new Date(initvalue.projectreqdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row class="no-gutters" style="margin-top: 10px;">
                    <v-col cols="12" md="12">
                      <v-row class="ma-0">
                        <p class="two-line" style="font-weight: 800;"><u>Project Description</u></p>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col>
                          <p class="two-line" v-html="initvalue.projectdesc.replace('\n', '<br>')"></p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div style="margin-bottom: 5px;">&nbsp;</div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-response'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="5">
                    <v-form>
                      <p class="text-h5">Project Response</p>
                      <v-select
                        class="mb-4"
                        :items="['Accept', 'Not Accept']"
                        v-model="update_project.projectstatus"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Response"
                        persistent-hint
                        single-line hint="Please choose the response">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=projectnotes[update_project.projectstatus]
                        v-model="update_project.projectnote"
                        v-bind:error="errorindex == 1"
                        outlined
                        dense
                        placeholder="Note"
                        persistent-hint
                        single-line hint="Please choose the response note">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="5">
                    <div class="d-flex justify-center">
                        <v-btn
                            @click="Done"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateCreativeProject()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>


    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      error: undefined,
      errortag: false,
      errorindex: undefined,

      initvalue: {},
      update_project: {},
      projectnotes: {
        "Accept":  [
          'Project will be started immediately', 
          'Project will be started tomorrow',
          'Project will be started in 2-5 days',
          'Project will be started next week',
          'Project will be started 2-3 weeks', 
        ],
        "Not Accept": [
          'Skillset does not match project requirements', 
          'Current project workloads too high', 
          'Other reasons'
        ]
      },
    }
  },
  computed: {
    ...mapState('CreativeProject', ['isReceiving']),
  },
  methods: {
    ...mapActions('CreativeProject', [ 'getCreativeProjectsRequest','updateCreativeProjectResponseRequest']),
    checkError(){
      if(!this.update_project.projectstatus){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.update_project.projectnote){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }

      this.errorindex = -1;
      return true;
    },
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else router.replace({ name: 'Dashboard' });
    },
    async updateCreativeProject() {
      if(!this.checkError()) return;
      this.update_project._id = this.initvalue._id;
      await this.updateCreativeProjectResponseRequest(this.update_project);
      this.Done();
    },
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'CreativeProjectList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
